export const STORAGE_KEYS = {
  TOKEN: "soomtech-admin-panel-token",
  SHOW_LOADING: "show_loading",
};

export const MAIN_FONT_FAMILY = "Outfit";

export const LOGIN_PAGE_BACKGROUND_IMAGE = require("../../assets/images/login-bg-image.jpg");

export const ADMIN_PANEL_EMAIL = "admin@gmail.com";
export const ADMIN_PANEL_PASSWORD = "!Password123456";

export const ENCRYPTION_SECRET_KEY =
  "fKoSJQQYtAuuTVlngu2zC4pWIbacvjQ9xQ9Fh7/86ok=";
